import React, { useEffect } from "react";
import { Box } from "@mui/material";
import "./InterActiveBanner.css";
import { Navigate, useNavigate } from "react-router-dom";

const bubbleData = [
  {
    label: "eCommerce",
    color: "#e74c3c",
    height: "120px",
    width: "120px",
    refer: 6,
  },
  {
    label: "Graphics",
    color: "#27ae60",
    height: "95px",
    width: "95px",
    refer: 1,
  },
  {
    label: "Promotion",
    color: "#2980b9",
    height: "85px",
    width: "85px",
    refer: 7,
  },
  {
    label: "Design",
    color: "#8e44ad",
    height: "70px",
    width: "70px",
    refer: 1,
  },
  {
    label: "Website",
    color: "#f39c12",
    height: "105px",
    width: "105px",
    refer: 17,
  },
  {
    label: "Influencer",
    color: "#6ab04c",
    height: "75px",
    width: "75px",
    refer: 11,
  },
  { label: "App", color: "#16a085", height: "65px", width: "65px", refer: 3 },
];

const clockSize = 180; // px
const orbitRadius = 120; // px distance from orbit center to bubbles

const InteractiveBanner = () => {
  const navigate = useNavigate();

  const showMessage = (label) => {
    // alert(`You clicked on ${label}`);
    navigate("/explore/" + label);
  };

  // Banner width & height for layout calculations
  const bannerWidth = window.innerWidth;
  const bannerHeight = window.innerHeight * 0.6; // 60vh

  // Orbit center: X near right side, Y vertically centered in banner height
  const orbitCenterX = bannerWidth * 0.75;
  const orbitCenterY = bannerHeight / 2;

  useEffect(() => {
    const hourRef = document.querySelector(".hour");
    const minuteRef = document.querySelector(".minute");
    const secondRef = document.querySelector(".second");

    const updateClock = () => {
      const date = new Date();
      const hours = ((date.getHours() + 11) % 12) + 1;
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();

      const hour = hours * 30;
      const minute = minutes * 6;
      const second = seconds * 6;

      if (hourRef) {
        hourRef.style.transform = `rotate(${hour}deg)`;
        hourRef.style.boxShadow = `${hour > 135 && hour < 315 ? "-" : ""}6px ${
          hour > 135 && hour < 315 ? "-" : ""
        }6px 6px #b8b9be`;
      }

      if (minuteRef) {
        minuteRef.style.transform = `rotate(${minute}deg)`;
        minuteRef.style.boxShadow = `${
          minute > 135 && minute < 315 ? "-" : ""
        }6px ${minute > 135 && minute < 315 ? "-" : ""}6px 6px #b8b9be`;
      }

      if (secondRef) {
        secondRef.style.transform = `rotate(${second}deg)`;
        if (second === 0) {
          secondRef.classList.add("hide-transition");
        } else {
          secondRef.classList.remove("hide-transition");
        }
        secondRef.style.boxShadow = `${
          second > 135 && second < 315 ? "-" : ""
        }6px ${second > 135 && second < 315 ? "-" : ""}6px 6px #b8b9be`;
      }
    };

    const interval = setInterval(updateClock, 1000);
    updateClock(); // initial call

    return () => clearInterval(interval); // cleanup
  }, []);
  return (
    <div style={{ ...styles.banner, height: "60vh" }}>
      {/* Clock container centered at orbit center */}
      <Box
        className="clock-container"
        sx={{
          height: clockSize,
          width: clockSize,
          position: "absolute",
          top: orbitCenterY,
          left: orbitCenterX,
          transform: "translate(-50%, -50%)",
          borderRadius: "50%",
          boxShadow: "0 0 8px rgba(0,0,0,0.2)",
          background: "#fff",
          zIndex: 10,
        }}
      >
        <Box
          className="clock"
          sx={{ position: "relative", height: "100%", width: "100%" }}
        >
          <span className="hour" />
          <span className="minute" />
          <span className="second" />
          <span className="axis" />
        </Box>
      </Box>

      {/* Bubbles arranged on orbit outside clock */}
      {bubbleData.map((bubble, index) => {
        const angle = (360 / bubbleData.length) * index * (Math.PI / 180);

        const margin = 20; // margin outside clock radius
        const radius = clockSize / 2 + margin + orbitRadius;

        const x = orbitCenterX + radius * Math.cos(angle);
        const y = orbitCenterY + radius * Math.sin(angle);

        return (
          <div
            key={index}
            style={{
              position: "absolute",
              top: y,
              left: x,
              transform: "translate(-50%, -50%)",
            }}
          >
            <div
              style={{
                position: "relative",
                width: bubble.width,
                height: bubble.height,
              }}
            >
              {/* Lines outside the bubble at 0°, 90°, 180°, 270° */}
              {[0, 90, 180, 270].map((angle, i) => {
                const radians = (angle * Math.PI) / 180;
                const radius =
                  Math.max(parseInt(bubble.width), parseInt(bubble.height)) / 2;
                const distance = radius + 10; // Push lines just outside the bubble

                const xOffset = distance * Math.cos(radians);
                const yOffset = distance * Math.sin(radians);

                return (
                  <div
                    key={`line-${i}`}
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: "2px",
                      height: "90px", // Adjust line length as needed
                      backgroundColor: "#f5f1f1",
                      transform: `translate(${xOffset}px, ${yOffset}px) rotate(${angle}deg)`,
                      transformOrigin: "center bottom",
                      boxShadow: "0 0 4px rgba(255,255,255,0.6)",
                    }}
                  />
                );
              })}

              {/* Bubble */}
              <div
                className="bubble-glow"
                style={{
                  width: bubble.width,
                  height: bubble.height,
                  backgroundColor: bubble.color,
                  borderRadius: "50%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  cursor: "pointer",
                }}
                onClick={() => showMessage(bubble.refer)}
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("bubble-spin");
                  e.currentTarget
                    .querySelector(".bubble-text")
                    .classList.add("bubble-text-spin");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("bubble-spin");
                  e.currentTarget
                    .querySelector(".bubble-text")
                    .classList.remove("bubble-text-spin");
                }}
              >
                <div
                  className="bubble-text"
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#fff",
                  }}
                >
                  {bubble.label}
                </div>
              </div>
              {/* <div
                className="bubble bubble-glow"
                style={{
                  backgroundColor: bubble.color,
                  width: bubble.width,
                  height: bubble.height,
                  borderRadius: "50%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => showMessage(bubble.label)}
              >
                <div className="bubble-text" style={{ color: "#fff" }}>
                  {bubble.label}
                </div>
              </div> */}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const styles = {
  banner: {
    width: "100vw",
    position: "relative",
    // background: "linear-gradient(#f9f9f9, #eaeaea)",
    overflow: "hidden",
    fontFamily: "sans-serif",
  },
  bubble: {
    borderRadius: "50%",
    padding: "15px 25px",
    color: "white",
    fontWeight: "bold",
    textAlign: "center",
    cursor: "pointer",
    transition: "transform 0.3s",
    whiteSpace: "nowrap",
    boxShadow: "0 0 5px rgba(0,0,0,0.2)",
  },
};

export default InteractiveBanner;
